export default __webpack_public_path__ + "static/media/icone-doc-assinado-pendencia.7a9f781c.png";